export default __webpack_public_path__ + "static/media/Step 4 Image.938c7868.png";